import React, { memo, SVGProps } from 'react'

export const ArrowDownSquare = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M16.9 3.29999H7.09999C4.99999 3.29999 3.29999 4.99999 3.29999 7.09999V16.9C3.29999 19 4.99999 20.7 7.09999 20.7H16.9C19 20.7 20.7 19 20.7 16.9V7.09999C20.7 4.99999 19 3.29999 16.9 3.29999ZM19.1 16.9C19.1 18.11 18.11 19.1 16.9 19.1H7.09999C5.88999 19.1 4.89999 18.11 4.89999 16.9V7.09999C4.89999 5.88999 5.88999 4.89999 7.09999 4.89999H16.9C18.11 4.89999 19.1 5.88999 19.1 7.09999V16.9Z"
      fill="currentColor"
    />
    <path
      d="M14.84 10.23L12 13.07L9.15999 10.23C8.84999 9.91999 8.33999 9.91999 8.02999 10.23C7.71999 10.54 7.71999 11.05 8.02999 11.36L11.44 14.77C11.59 14.92 11.79 15 12.01 15C12.23 15 12.43 14.92 12.58 14.77L15.99 11.36C16.3 11.05 16.3 10.54 15.99 10.23C15.68 9.91999 15.17 9.91999 14.86 10.23H14.84Z"
      fill="currentColor"
    />
  </svg>
))
